import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

// Services
import { IGetTaxonomyResponse, getTaxonomy } from '../../services/tag';
import { personAddTag, personRemoveTag } from '../../services/relation';

// Types
type ITaxonomyData = IGetTaxonomyResponse;

// Components
import Grid from '../../components/Grid';
import { CircularProgress } from '../../components/Progress';
import TaxonomyCanvas, { ITaxonomyTag } from '../../components/TaxonomyCanvas';

// Component
interface IProps {
  networkId: string;
  userId: string;
  userRole: 'USER' | 'ADMIN';
}

class UserDialogTagsTaxonomy extends React.Component<IProps, {}> {
  taxonomyRef: TaxonomyCanvas | null = null;
  @observable.ref taxonomyData: ITaxonomyData | null = null;

  componentDidMount() {
    this.getTaxonomy();
  }

  async getTaxonomy() {
    this.taxonomyData = await getTaxonomy({
      params: { networkId: this.props.networkId },
      query: { userId: this.props.userId }
    });
  }

  handleTaxonomyRef = (ref: TaxonomyCanvas) => {
    this.taxonomyRef = ref;
  };

  handleTitleClick = async (tag: ITaxonomyTag) => {
    if (this.props.userRole === 'ADMIN') {
      if (tag.tagged === true) {
        await personRemoveTag({
          params: {
            networkId: this.props.networkId
          },
          query: {
            tagId: tag.tagId,
            userId: this.props.userId
          }
        });
      } else {
        await personAddTag({
          params: {
            networkId: this.props.networkId
          },
          query: {
            tagId: tag.tagId,
            userId: this.props.userId
          }
        });
      }
      this.taxonomyRef!.editItem({
        ...tag,
        tagged: !tag.tagged
      });
    }
  };

  render() {
    if (this.taxonomyData === null) {
      return (
        <Grid
          container={true}
          direction="column"
          alignItems="center"
          justify="center"
          spacing={0}
          style={{ height: 400 }}
        >
          <CircularProgress />
        </Grid>
      );
    }
    return (
      <div>
        <TaxonomyCanvas
          ref={this.handleTaxonomyRef}
          taxonomyData={this.taxonomyData}
          onTitleClick={this.handleTitleClick}
          headings={true}
        />
      </div>
    );
  }
}

export default observer(UserDialogTagsTaxonomy);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/UserDialogTagsTaxonomy.tsx